module.exports = __webpack_public_path__ + "img/eth-logo.09da591a.svg";